// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".organism-guided-tour-timeline{align-items:center;background:#fff;border-radius:.5rem;bottom:1.25rem;box-shadow:0 0 .063rem .063rem #f7f7f7;display:flex;left:50%;max-width:70%;overflow:auto;padding:1rem 3rem 2.4rem;position:absolute;transform:translateX(-50%);z-index:5}@media only screen and (max-width:767px){.organism-guided-tour-timeline{bottom:10px;left:2%;max-width:96%;transform:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
